import classNames from 'classnames';
import {get} from 'lodash';
import compact from 'lodash/compact';
import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import Dropzone from 'react-dropzone';
import swal from 'sweetalert2';
import './index.css';

class UpdateJersey extends React.Component {
  state = {
    checkbox: !this.props.data.endDate,
    checkboxCustom: !!this.props.data.isCustom,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data.id !== this.props.data.id) {
      this.setState({
        data: this.props.data,
        checkboxCustom: !!this.props.data.isCustom,
        checkbox: !this.props.data.endDate,
      });
    }
  }

  submitCreateOrEdit(edit) {
    const {submit, editJersey, data} = this.props;

    const allInputs = [
      'code',
      'localization.fr-FR.name',
      'localization.en-GB.name',
      'localization.es-ES.name',
      'localization.fr-FR.description',
      'localization.en-GB.description',
      'localization.es-ES.description',
      'productCode',
      'tag',
      'startDate',
      'imageUrl',
    ];

    const excludedInputs = ['tag'];

    const inputs = allInputs.filter(e => !excludedInputs.includes(e));

    const errors = inputs.map(i => {
      if (!get(data, i)) {
        this.setState({[`${i}Error`]: true});
        return true;
      }
      this.setState({[`${i}Error`]: false});
      return false;
    });
    if (compact(errors).length === 0) {
      edit ? editJersey() : submit();
    }
  }

  render() {
    const {edit, data, onChangeInput, onUpload} = this.props;

    const {productCodeError, imageUrlError, startDateError, codeError} =
      this.state;

    return (
      <div id="updateJersey" className="col-md-6">
        <div className="box box-default">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              {edit ? `Editing ${data.code}` : 'Create new jersey'}
            </h3>
          </div>
          <div style={{padding: '15px'}}>
            <div className="infoWrapper">
              <div className="keys">Code</div>
              <div className="name">
                <div className="nameContainer">
                  <div
                    className={classNames(
                      'form-group',
                      codeError && 'has-error',
                    )}>
                    <input
                      className="form-control"
                      value={data.code || ''}
                      onChange={event =>
                        console.log(event.target.value) ||
                        onChangeInput(event.target.value, 'code')
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {edit && (
              <div>
                <div className="infoWrapper">
                  <div className="keys">ID</div>
                  <div className="values">{data.id}</div>
                </div>
                <hr />
              </div>
            )}
            <div className="infoWrapper">
              <div className="keys">Name</div>
              <div className="name">
                <div className="nameContainer">
                  <div>fr-FR</div>
                  <div
                    className={classNames(
                      'form-group',
                      this.state['localization.fr-FR.nameError'] && 'has-error',
                    )}>
                    <input
                      className="form-control"
                      value={get(data, 'localization.fr-FR.name')}
                      onChange={event =>
                        onChangeInput(
                          event.target.value,
                          'localization.fr-FR.name',
                        )
                      }
                    />
                  </div>
                </div>
                <div className="nameContainer">
                  <div>en-GB</div>
                  <div
                    className={classNames(
                      'form-group',
                      this.state['localization.en-GB.nameError'] && 'has-error',
                    )}>
                    <input
                      className="form-control"
                      value={get(data, 'localization.en-GB.name')}
                      onChange={event =>
                        onChangeInput(
                          event.target.value,
                          'localization.en-GB.name',
                        )
                      }
                    />
                  </div>
                </div>
                <div className="nameContainer">
                  <div>es-ES</div>
                  <div
                    className={classNames(
                      'form-group',
                      this.state['localization.es-ES.nameError'] && 'has-error',
                    )}>
                    <input
                      className="form-control"
                      value={get(data, 'localization.es-ES.name')}
                      onChange={event =>
                        onChangeInput(
                          event.target.value,
                          'localization.es-ES.name',
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className={'keys'}>Description</div>
              <div className="name">
                <div className="nameContainer">
                  <div>fr-FR</div>
                  <div
                    className={classNames(
                      'form-group',
                      this.state['localization.fr-FR.descriptionError'] &&
                        'has-error',
                    )}>
                    <textarea
                      className="form-control"
                      value={get(data, 'localization.fr-FR.description')}
                      onChange={event =>
                        onChangeInput(
                          event.target.value,
                          'localization.fr-FR.description',
                        )
                      }
                    />
                  </div>
                </div>
                <div className="nameContainer">
                  <div>en-GB</div>
                  <div
                    className={classNames(
                      'form-group',
                      this.state['localization.en-GB.descriptionError'] &&
                        'has-error',
                    )}>
                    <textarea
                      className="form-control"
                      value={get(data, 'localization.en-GB.description')}
                      onChange={event =>
                        onChangeInput(
                          event.target.value,
                          'localization.en-GB.description',
                        )
                      }
                    />
                  </div>
                </div>
                <div className="nameContainer">
                  <div>es-ES</div>
                  <div
                    className={classNames(
                      'form-group',
                      this.state['localization.es-ES.descriptionError'] &&
                        'has-error',
                    )}>
                    <textarea
                      className="form-control"
                      value={get(data, 'localization.es-ES.description')}
                      onChange={event =>
                        onChangeInput(
                          event.target.value,
                          'localization.es-ES.description',
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">Price</div>
              <div
                className={classNames(
                  'form-group',
                  productCodeError && 'has-error',
                )}>
                <select
                  className="form-control"
                  value={data.productCode || ''}
                  onChange={event =>
                    onChangeInput(event.target.value, 'productCode')
                  }>
                  <option value={null} />
                  <option value="free">free</option>
                  <option value="jersey_10">0.99€</option>
                  <option value="jersey_20">2.49€</option>
                  <option value="jersey_50">4.99€</option>
                </select>
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div className="keys">Label</div>
              <div>
                <select
                  className="form-control"
                  value={data.tag || ''}
                  onChange={event => {
                    onChangeInput(event.target.value, 'tag');
                  }}>
                  <option value="" />
                  <option value="new">new</option>
                  <option value="limited">limited</option>
                  <option value="free">free</option>
                  <option value="onDiscount">onDiscount</option>
                </select>
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div style={{color: imageUrlError && 'red'}} className="keys">
                Visual
              </div>
              {data.imageUrl && (
                <div className="jerseyItem">
                  <img src={`${data.imageUrl}`} width="90px" alt="" />
                </div>
              )}
              <div style={{marginLeft: '20px'}}>
                <Dropzone
                  onDrop={acceptedFiles => {
                    const img = new Image();
                    img.src = acceptedFiles[0].preview;
                    img.onload = value => {
                      if (img?.width !== 500 || img?.height !== 500) {
                        swal({
                          title: `Oops...`,
                          type: 'error',
                          html: `Wrong dimensions: ${img?.width} X ${img?.height}<br/>Accepted dimensions: 500 x 500<br/>`,
                        });
                      } else {
                        onUpload(acceptedFiles[0]);
                      }
                    };
                  }}
                  className="btn btn-warning">
                  Upload
                </Dropzone>
              </div>
            </div>
            <hr />
            <div className="infoWrapper">
              <div style={{color: startDateError && 'red'}} className="keys">
                Available
              </div>
              <div className="nameContainer">
                <div style={{color: startDateError && 'red'}}>Start</div>
                <div>
                  <DatePicker
                    className="inputDatePicker"
                    selected={
                      (data.startDate && new Date(data.startDate)) || null
                    }
                    onChange={date => {
                      console.log(date);
                      onChangeInput(moment(date).utc().format(), 'startDate');
                    }}
                    dateFormat="d/M/yyyy hh:mm aa"
                    showTimeSelect
                    timeIntervals={15}
                    placeholderText="Select Date"
                  />
                </div>
              </div>
              {!this.state.checkbox && (
                <div className="nameContainer">
                  <div>End</div>
                  <DatePicker
                    className="inputDatePicker"
                    selected={(data.endDate && new Date(data.endDate)) || null}
                    onChange={date => {
                      this.setState({checkbox: false});
                      onChangeInput(moment(date).utc().format(), 'endDate');
                    }}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="d/M/yyyy hh:mm aa"
                    timeCaption="time"
                    placeholderText="Select Date"
                  />
                </div>
              )}
              <div className="nameContainer">
                <div>No limit</div>
                <input
                  type="checkbox"
                  checked={this.state.checkbox}
                  onChange={() => {
                    onChangeInput(null, 'endDate');
                    this.setState({checkbox: !this.state.checkbox});
                  }}
                />
              </div>
            </div>
            <hr />
            <div className="text-center">
              <button
                className="btn btn-success"
                onClick={() => this.submitCreateOrEdit(edit)}>
                {edit ? 'Modifier' : 'Create'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UpdateJersey;



// WEBPACK FOOTER //
// ./src/pages/Jerseys/UpdateJersey/index.js